<template>
  <div id="app">
    <!-- <div class = "case_div">
      <img class="home_banner" :src="Detail.topImg" />
      <div class="div_top_title">
        <div class="flex-container">
          <p id="toptitle" ref="element">{{ Detail.title }}</p>
          <p id="topsubtitle" class="p_title_sub">{{ Detail.subtitle }}</p>
        </div>
        <p id="litter_line_top" class="litter_line_top"></p>
      </div>
    </div> -->
    <div class="father_div">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class="left_div">
            <div class="left_div_top">
              <div style="width: 100%">
                <div class="Medium">
                  <img :src="Detail.cover" />
                </div>
                <p class="sub_heading Medium">{{ Detail.subtitle }}</p>
                <div class="tv_content Medium">
                  <p>
                    {{ Detail.simple }}
                  </p>
                </div>
                <div class="litter_line"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class="right_div">
            <div class="left_div_bottom">
              <img :src="Detail.showImg" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="middle_div">
      <div class="row row_div">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 mid-flex-container">
          <img class="img_icon" :src="Detail.midLeftTopImg" />
          <div class="sub_content_div">
            <p class="sub_p_1">{{ Detail.midLeftTopTitle }}</p>
            <p class="sub_p_2">{{ Detail.midLeftTopCon }}</p>
          </div>
        </div>
        <div
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 mid-flex-container right_sub_div"
        >
          <img class="img_icon" :src="Detail.midRightTopImg" />
          <div class="sub_content_div_right">
            <p class="sub_p_1">{{ Detail.midRightTopTitle }}</p>
            <p class="sub_p_2">{{ Detail.midRightTopCon }}</p>
          </div>
        </div>
      </div>
      <div class="row row_div" v-show="showBottomImg">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 mid-flex-container">
          <img class="img_icon" :src="Detail.midLeftBottomImg" />
          <div class="sub_content_div">
            <p class="sub_p_1">{{ Detail.midLeftBottomTitle }}</p>
            <p class="sub_p_2">{{ Detail.midLeftBottomCon }}</p>
          </div>
        </div>
        <div
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 mid-flex-container right_sub_div"
        >
          <img class="img_icon" :src="Detail.midRightBottomImg" />
          <div class="sub_content_div_right">
            <p class="sub_p_1">{{ Detail.midRightBottomTitle }}</p>
            <p class="sub_p_2">{{ Detail.midRightBottomCon }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-html="Detail.content"></div>
  </div>
</template>

<script>
export default {
  components: {},
  showBottomImg:true,
  data() {
    return {
      Detail: [],
    };
  },
  mounted: function () {
    this.getDetail();
  },

  watch: {
    //监听路由变化
  },
  methods: {
    getEleWidth() {
      var a = $("#toptitle").outerWidth(true), //width()返回元素的宽高，不包括padding/border/margin
        b = $("#topsubtitle").outerWidth(true);
      console.log(a, b);
      this.setEleWidth(a + b);
    },
    removeElemargin() {
      var a = $("#topsubtitle").css("margin-left", 0);
      console.log(a);
    },
    setEleWidth(a, b) {
      if (b > 20) {
        $("#litter_line_top").width(a + b - 20);
      } else {
        $("#litter_line_top").width(a - 20);
      }
    },
    getDetail() {
      this.$axios
        .get("api/case/info", {
          params: {
            id: window.location.href.split("id=")[1],
            plate: sessionStorage.getItem("plate"),
            business: sessionStorage.getItem("business"),
          },
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.Detail = response.data.data;
              if(this.Detail.midLeftBottomImg){
                this.showBottomImg=true;
              }else{
                this.showBottomImg=false;

              }
              document.title = this.Detail.title;
              setTimeout(() => {
                var sub = this.Detail.subtitle;
                if (!sub && typeof sub != "undefined" && sub != 0) {
                  //判断null
                  this.removeElemargin();
                }
                // this.getEleWidth();
              }, 1000);
            }
          }.bind(this)
        );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.case_div {
  height: 100%;
  position: relative;
}

.home_banner {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: var(--textBlue);

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.father_div {
  margin: 10rem auto 0;
  width: 70%;
  padding: 5rem 0;
}

.middle_div {
  background: #ffffff;
  margin: 4rem 0;
  width:70%;
  margin:auto;
  padding: 4rem 0;

  .row_div {
    width: 100%;
    margin: auto;
    padding: 2rem 0;

    .right_sub_div {
      // margin-left: 1rem;
    }
  }

  img {
    width: 6rem;
    height: 6rem;
    margin: 0;
    object-fit: contain;
  }

  .sub_content_div {
    margin: 0 2rem;
    text-align: left;

    .sub_p_1 {
      font-size: 1.8rem;
      color: var(--textBlue);
    }

    .sub_p_2 {
      font-size: 1.4rem;
      color: #595757;
      line-height: 2.5rem;
      font-family: light;
    }
  }

  .sub_content_div_right {
    margin: 0 0 0 2rem;
    text-align: justify;

    .sub_p_1 {
      font-size: 1.8rem;
      color: var(--textBlue);
    }

    .sub_p_2 {
      font-size: 1.4rem;
      color: #595757;
      line-height: 2.5rem;
      font-family: light;
    }
  }
}

.img_icon {
  img {
    width: 6rem;
    height: 6rem;
    margin: 0;
    object-fit: contain;
  }
}

.heading {
  margin: 0;
  font-size: 3rem;
  color: var(--textBlue);
  text-align: left;
  font-family: bold;
}

.litter_line {
  box-sizing: border-box;
  background-color: black;
  height: 1px;
  width: 100%;
  position: absolute;
  bottom: 0;
}

.div_top_title {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  color: white;
  font-size: 6rem;
  font-family: bold;

  .p_title_sub {
    font-size: 4rem;
    font-family: regular;
    margin: 0 0 0 1rem;
  }

  .litter_line_top {
    margin: 0 auto;
    background-color: white;
    height: 2px;
    width: 10%;
  }
}

.flex-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.mid-flex-container {
  display: flex;
  // margin:0 -15px;
  padding:0;
  // align-items: center;
  justify-content: center;
}

.flex-container > div {
  padding: 0 20px 0 0;
}

.sub_heading {
  font-size: 3.8rem;
  color: #595757;
  text-align: left;
  margin: 1rem 0;
}

.tv_content {
  position: absolute;
  bottom: 1rem;
  box-sizing: border-box;
  height: auto;
  font-size: 1.4rem;
  color: #595757;
  text-align: left;
  line-height: 2.5rem;
  display: block;
  font-family: light;
}

.left_div {
  height: 100%;
}

.left_div_top {
  min-height: 35rem;
  width: 100%;
  display: block;
  position: relative;

  img {
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    object-fit: cover;
  }
}

.left_div_bottom {
  height: 35rem;

  img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.right_div {
  height: 100%;
  width: 100%;
}

.Medium {
  text-align: left;
}

// @media screen and (max-width: 1600px) {
//   .left_div_top {
//     min-height: 35rem;
//   }

//   .left_div_bottom {
//     min-height: 35rem;
//   }
// }
</style>
